<template>
    <div class="user-form">
        <div class="user-search-bar">
            <label class="user-search-bar__label" for="user-search">Search users</label>
            <input id="user-search" type="text" class="mdc-text-field__input" placeholder="請在此輸入相關名稱" v-on:keyup="onChange"/>
        </div>
        <div class="user-result">
            <div class="user-result__action">
                <span class="user-result__label">
                    候選佳麗(未認證用戶為紅色)
                </span>
            </div>
            <ul class="user-result-list mdc-list" data-mdc-auto-init="MDCList">
                <li  v-for="(user, index) in result" class="user-result-item mdc-list-item" :data-id="user.id" v-on:click.prevent="onClick">
                    <label :for="'list-result-'+ index" :style="{ color: user.email_verified_at ? '' : 'red' }"> [{{user.id}}] {{ user.name }} [{{user.email}}] </label>
                    <div class="user-checks mdc-checkbox mdc-list-item__meta">
                        <input :id="'list-result-'+ index" type="checkbox" name="users[]" :value="user.id" class="mdc-checkbox__native-control" disabled/>
                        <div class="mdc-checkbox__background">
                            <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                                <path class="mdc-checkbox__checkmark-path" fill="none" stroke="white" d="M1.73,12.91 8.1,19.28 22.79,4.59"></path>
                            </svg>
                            <div class="mdc-checkbox__mixedmark"></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div v-show="!result.length" class="user-search-hint-box">
            <span class="user-search-hint-box__text">
                請在上方搜尋相關店鋪
            </span>
        </div>

        <hr class="user-hr">
        <div class="user-selected">
            <div class="user-result__action">
                <span class="user-result__label">
                    已選擇(單個選取）
                </span>
            </div>
            <ul class="user-selected-list mdc-list" data-mdc-auto-init="MDCList">
                <li v-show="selected" class="user-selected-item mdc-list-item" :data-id="selected.id" v-on:click.prevent="onClick">
                    <label for="list-selected">[{{selected.id}}] {{ selected.name }} [{{selected.email}}]</label>
                    <div class="categories-checks mdc-checkbox mdc-list-item__meta">
                        <input id="list-selected" type="checkbox" name="owner_id" :value="selected.id" class="mdc-checkbox__native-control" v-model="selected"/>
                        <div class="mdc-checkbox__background">
                            <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                                <path class="mdc-checkbox__checkmark-path" fill="none" stroke="white" d="M1.73,12.91 8.1,19.28 22.79,4.59"></path>
                            </svg>
                            <div class="mdc-checkbox__mixedmark"></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'user': {
                default: false,
            }
        },
        data() {
            return {
                'result': [],
                'searchUrl': '/admin/users/select-user-list/search',
                'request': null,
                'mdcList': [],
                'selected': this.user,
            }
        },
        methods: {
            onChange: function (e) {
                let name = $(e.target).val();
                let url = this.searchUrl + '?name=' + name;

                clearTimeout($(e.currentTarget).data('timer'));

                let timer = setTimeout(function () {

                    this.request = $.ajax({
                        url: url,
                        beforeSend: function () {
                            if (this.request != null) {
                                this.request.abort();
                            }

                            popsale.loading(true)
                        }.bind(this),
                        success: function (response) {
                            if (response.length < 1) {
                                popsale.snackText('沒有任何數據');
                            }

                            this.result = response;
                        }.bind(this),
                        complete: function () {
                            if (this.request) {
                                this.request = null;
                            }

                            popsale.loading(false)
                        }.bind(this),
                    });

                }.bind(this), 1000);

                $(e.currentTarget).data('timer', timer);

                return false;
            },
            onClick: function (e) {
                if ($(e.currentTarget).hasClass('user-selected-item')) {
                    this.selected = false;
                    return
                }

                let data = $(e.currentTarget).data('id');
                let users = $.grep(this.result, function (e) {
                    return e.id === data;
                });

                if (users.length > 0) {
                    this.selected = users[0];
                }
            }
        },
        mounted() {
            /**
             * Disable enter key action that trigger from user search bar
             */
            $(window).on('keydown', function (event) {
                if (event.keyCode === 13 && event.target.id === 'user-search') {
                    event.preventDefault();
                    return false;
                }
            });
        }
    }
</script>

<style lang="scss">
    .user-search-bar {
        position: relative;
        background-color: #efefef;
        border-radius: 2px 2px 0 0;
        & > input {
            border-color: var(--mdc-theme-primary);
        }

        &__label {
            position: absolute;
            font-size: 0.7em;
            top: 0;
            left: 10px;
            color: var(--mdc-theme-primary);
        }
    }

    .user-result, .user-selected {
        max-height: 300px;
        overflow-x: hidden;
        overflow-y: auto;

        &__action {
            position: sticky;
            display: flex;
            top: 0;
            z-index: 1;
            text-align: center;
            align-items: center;
            width: 100%;
            padding: 5px 0;
            border-bottom: 1px black solid;
            background-color: white;

            .user-option-button {
                height: 30px;
                margin-left: auto;
            }
        }

        &__label {
            font-size: 1em;
            font-weight: 500;
            color: #9a9a9a;
        }
    }

    .user-selected-item, .user-result-item {
        height: 35px;
    }

    .user-search-hint-box {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 120px;

        &__text {
            font-weight: 500;
            font-size: 1.2em;
        }
    }

    hr.user-hr {
        border-color: black;
    }

    li > label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>